export default __webpack_public_path__ + "static/media/lions_current_chairman.dd0796ee.png";